import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { find, includes } from "lodash";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import { Nav, NavItem, UncontrolledCollapse, Badge } from "reactstrap";
import { NavLink, withRouter } from "react-router-dom";
import classnames from "classnames";
import PerfectScrollbar from "react-perfect-scrollbar";
import IntlMessages from "../../helpers/IntlMessages";
import { setContainerClassnames, addContainerClassname, changeDefaultClassnames, changeSelectedMenuHasSubItems } from "../../redux/menu/actions";
import menuItems from "../../constants/menu";
import getHotelConfig from "../../getHotelConfig";

let unconfirmedCount = 0;
let openCount = 0;
let fastCheckinCount = 0;
let openLolRequestsCount = 0;
let awaitingBookingNotificationsArr = [];
let openRequestNotificationsArr = [];
let openFastCheckinNotificationsArr = [];
let openLolRequestsNotificationsArr = [];
let openRequestAndAwaitingBookingNotificationsArr = [];
let countArr = [];

class Sidebar extends Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      selectedParentMenu: "",
      viewingParentMenu: "",
      menuItems: ""
    };
  }

  // componentWillReceiveProps - deprecated - instead of static getDerivedStateFromProps
  static getDerivedStateFromProps({ allRequestItems, allFastCheckinItems, allBookingItems, allLolRequestsItems }) {
    unconfirmedCount = 0;
    openCount = 0;
    fastCheckinCount = 0;
    openLolRequestsCount = 0;
    awaitingBookingNotificationsArr = [];
    openRequestNotificationsArr = [];
    openFastCheckinNotificationsArr = [];
    openRequestAndAwaitingBookingNotificationsArr = [];
    openLolRequestsNotificationsArr = [];
    if (allBookingItems && Object.values(allBookingItems) && Object.values(allBookingItems).length) {
      Object.values(allBookingItems).forEach(booking => {
        const bookingId = booking.id;
        if (booking && booking.status === "awaiting_approval") {
          const awaitingBookingNotification = {
            iClassName: "iconsminds-id-card",
            clickAction: `/app/staff/bookings/${bookingId}`,
            title: booking.fullName,
            date: booking.updated_at_date,
            updatedAt: booking.updated_at,
            id: booking.id
          };
          awaitingBookingNotificationsArr = awaitingBookingNotificationsArr.concat(awaitingBookingNotification);
          unconfirmedCount += 1;
        }
      });
    }
    if (allRequestItems && Object.values(allRequestItems) && Object.values(allRequestItems).length) {
      Object.values(allRequestItems).forEach(request => {
        const requestId = request.id;
        if (request && request.status === "OPEN" && request.service_type !== "FAST_CHECK_IN") {
          const openRequestNotification = {
            iClassName: "iconsminds-check",
            clickAction: `/app/staff/requests/${requestId}`,
            title: request.serviceName,
            date: request.updated_at_date,
            updatedAt: request.updated_at,
            id: requestId
          };
          openRequestNotificationsArr = openRequestNotificationsArr.concat(openRequestNotification);
          if (!(request.service?.is_easee_service === "true")) {
            openCount += 1;
          }
        }
      });
    }
    if (allFastCheckinItems && Object.values(allFastCheckinItems) && Object.values(allFastCheckinItems).length) {
      Object.values(allFastCheckinItems).forEach(request => {
        const requestId = request.id;
        if (request && request.status === "OPEN") {
          const openRequestFastCheckinNotification = {
            iClassName: "iconsminds-check",
            clickAction: `/app/staff/fastCheckin/${requestId}`,
            title: request.serviceName,
            date: request.updated_at_date,
            updatedAt: request.updated_at,
            id: requestId
          };
          openFastCheckinNotificationsArr = openFastCheckinNotificationsArr.concat(openRequestFastCheckinNotification);
          fastCheckinCount += 1;
        }
      });
    }
    if (allLolRequestsItems && Object.values(allLolRequestsItems) && Object.values(allLolRequestsItems).length) {
      Object.values(allLolRequestsItems).forEach(request => {
        const requestId = request.id;
        if (request && request.status === "OPEN") {
          const openLolRequestsNotification = {
            iClassName: "iconsminds-check",
            clickAction: `/app/staff/lolRequests/${requestId}`,
            title: request.serviceName,
            date: request.updated_at_date,
            updatedAt: request.updated_at,
            id: requestId
          };
          openLolRequestsNotificationsArr = openLolRequestsNotificationsArr.concat(openLolRequestsNotification);
          openLolRequestsCount += 1;
        }
      });
    }

    countArr = [openCount, unconfirmedCount, fastCheckinCount, openLolRequestsCount];
    openRequestAndAwaitingBookingNotificationsArr = [
      ...openRequestNotificationsArr,
      ...openFastCheckinNotificationsArr,
      ...awaitingBookingNotificationsArr,
      ...openLolRequestsNotificationsArr
    ];
    openRequestAndAwaitingBookingNotificationsArr = openRequestAndAwaitingBookingNotificationsArr.sort((a, b) => {
      if (parseInt(a.updatedAt, 10) > parseInt(b.updatedAt, 10)) return -1;
      if (parseInt(a.updatedAt, 10) < parseInt(b.updatedAt, 10)) return 1;
      return 0;
    });

    // for Request and booking list icon
    // openRequestNotification = [ ...openRequestNotificationsArr ];
    // openBookingNotification = [ ...awaitingBookingNotificationsArr ];

    // openRequestNotification = openRequestNotification.sort((a, b) => {
    //   if (parseInt(a.updatedAt, 10) > parseInt(b.updatedAt, 10)) return -1;
    //   if (parseInt(a.updatedAt, 10) < parseInt(b.updatedAt, 10)) return 1;
    //   return 0;
    // });

    // openBookingNotification = openBookingNotification.sort((a, b) => {
    //   if (parseInt(a.updatedAt, 10) > parseInt(b.updatedAt, 10)) return -1;
    //   if (parseInt(a.updatedAt, 10) < parseInt(b.updatedAt, 10)) return 1;
    //   return 0;
    // });
    return { unconfirmedCount, openCount };
  }

  async componentDidMount() {
    this._isMounted = true;
    window.addEventListener("resize", this.handleWindowResize);
    this.handleWindowResize();
    this.handleProps();
    this.setSelectedLiActive(this.setHasSubItemStatus);
    this.openRequest();
    this.openBooking();
    await this.menuItemsFunc(menuItems);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.setSelectedLiActive(this.setHasSubItemStatus);

      window.scrollTo(0, 0);
    }
    this.handleProps();
    // if(this.state.openBookingCount !== prevState.openBookingCount){
    //   // alert(this.state.openBookingCount)
    //   this.openBooking();
    // }
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.removeEvents();
    window.removeEventListener("resize", this.handleWindowResize);
  }

  openBooking = () => {
    if (this.props.allBookingItems && Object.values(this.props.allBookingItems) && Object.values(this.props.allBookingItems).length) {
      let bookingOpen = 0;
      const openbooking = Object.values(this.props.allBookingItems).map(booking => {
        if (booking && booking.status === "awaiting_approval") {
          bookingOpen += 1;
        }
      });
      this.setState({
        openBookingCount: bookingOpen
      });
      return openbooking;
    }
  };

  openRequest = () => {
    if (this.props.allRequestItems && Object.values(this.props.allRequestItems) && Object.values(this.props.allRequestItems).length) {
      let requestOpen = 0;
      const openReq = Object.values(this.props.allRequestItems).forEach(request => {
        if (request && request.status === "OPEN") {
          requestOpen += 1;
        }
      });
      this.setState({
        openRequestCount: requestOpen
      });
      return openReq;
    }
  };

  handleWindowResize = event => {
    if (event && !event.isTrusted) {
      return;
    }
    const { containerClassnames } = this.props;
    const nextClasses = this.getMenuClassesForResize(containerClassnames);
    this.props.setContainerClassnames(0, nextClasses.join(" "), this.props.selectedMenuHasSubItems);
  };

  getMeta = metaName => {
    if (document) {
      const metas = document.getElementsByTagName("meta");

      for (let i = 0; i < metas.length; i++) {
        if (metas[i].getAttribute("name") === metaName) {
          return metas[i].getAttribute("content");
        }
      }
    }

    return "";
  };

  handleDocumentClick = e => {
    const container = this.getContainer();
    let isMenuClick = false;
    if (e.target && e.target.classList && (e.target.classList.contains("menu-button") || e.target.classList.contains("menu-button-mobile"))) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.classList &&
      (e.target.parentElement.classList.contains("menu-button") || e.target.parentElement.classList.contains("menu-button-mobile"))
    ) {
      isMenuClick = true;
    } else if (
      e.target.parentElement &&
      e.target.parentElement.parentElement &&
      e.target.parentElement.parentElement.classList &&
      (e.target.parentElement.parentElement.classList.contains("menu-button") ||
        e.target.parentElement.parentElement.classList.contains("menu-button-mobile"))
    ) {
      isMenuClick = true;
    }
    if (container.contains(e.target) || container === e.target || isMenuClick) {
      return;
    }
    this.setState({
      viewingParentMenu: ""
    });
    this.toggle();
  };

  getMenuClassesForResize = classes => {
    const { menuHiddenBreakpoint, subHiddenBreakpoint } = this.props;
    let nextClasses = classes.split(" ").filter(x => x !== "");
    const windowWidth = window.innerWidth;
    if (windowWidth < menuHiddenBreakpoint) {
      nextClasses.push("menu-mobile");
    } else if (windowWidth < subHiddenBreakpoint) {
      nextClasses = nextClasses.filter(x => x !== "menu-mobile");
      if (nextClasses.includes("menu-default") && !nextClasses.includes("menu-sub-hidden")) {
        nextClasses.push("menu-sub-hidden");
      }
    } else {
      nextClasses = nextClasses.filter(x => x !== "menu-mobile");
      if (nextClasses.includes("menu-default") && nextClasses.includes("menu-sub-hidden")) {
        nextClasses = nextClasses.filter(x => x !== "menu-sub-hidden");
      }
    }
    return nextClasses;
  };

  getContainer = () => {
    return ReactDOM.findDOMNode(this);
  };

  toggle = () => {
    const hasSubItems = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubItems);
    const { containerClassnames, menuClickCount } = this.props;
    const currentClasses = containerClassnames ? containerClassnames.split(" ").filter(x => x !== "") : "";
    let clickIndex = -1;

    if (!hasSubItems) {
      if (currentClasses.includes("menu-default") && (menuClickCount % 4 === 0 || menuClickCount % 4 === 3)) {
        clickIndex = 1;
      } else if (currentClasses.includes("menu-sub-hidden") && (menuClickCount === 2 || menuClickCount === 3)) {
        clickIndex = 0;
      } else if (currentClasses.includes("menu-hidden") || currentClasses.includes("menu-mobile")) {
        clickIndex = 0;
      }
    } else if (currentClasses.includes("menu-sub-hidden") && menuClickCount === 3) {
      clickIndex = 2;
    } else if (currentClasses.includes("menu-hidden") || currentClasses.includes("menu-mobile")) {
      clickIndex = 0;
    }
    if (clickIndex >= 0) {
      this.props.setContainerClassnames(clickIndex, containerClassnames, hasSubItems);
    }
  };

  handleProps = () => {
    this.addEvents();
  };

  addEvents = () => {
    ["click", "touchstart", "touchend"].forEach(event => document.addEventListener(event, this.handleDocumentClick, true));
  };

  removeEvents = () => {
    ["click", "touchstart", "touchend"].forEach(event => document.removeEventListener(event, this.handleDocumentClick, true));
  };

  setSelectedLiActive = callback => {
    const oldli = document.querySelector(".sub-menu  li.active");
    if (oldli != null) {
      oldli.classList.remove("active");
    }

    /* set selected parent menu */
    const selectedlink = document.querySelector(".sub-menu  a.active");
    if (selectedlink != null) {
      selectedlink.parentElement.classList.add("active");
      this.setState(
        {
          selectedParentMenu: selectedlink.parentElement.parentElement.getAttribute("data-parent")
        },
        callback
      );
    } else {
      const selectedParentNoSubItem = document.querySelector(".main-menu  li a.active");
      if (selectedParentNoSubItem != null) {
        this.setState(
          {
            selectedParentMenu: selectedParentNoSubItem.getAttribute("data-flag")
          },
          callback
        );
      } else if (this.state.selectedParentMenu === "") {
        const {
          location: { pathname }
        } = this.props;

        let selectedParentMenu = menuItems[0].id;
        const activeMenuItem = find(menuItems, ({ to }) => includes(pathname, to));
        if (activeMenuItem) selectedParentMenu = activeMenuItem.id;

        this.setState(
          {
            selectedParentMenu
          },
          callback
        );
      }
    }
  };

  setHasSubItemStatus = () => {
    const hasSubmenu = this.getIsHasSubItem();
    this.props.changeSelectedMenuHasSubItems(hasSubmenu);
    this.toggle();
  };

  getIsHasSubItem = () => {
    const { selectedParentMenu } = this.state;
    const menuItem = menuItems.find(x => x.id === selectedParentMenu);
    if (menuItem) return !!(menuItem && menuItem.subs && menuItem.subs.length > 0);
    return false;
  };

  menuItemsFunc = async menuItems => {
    const hotelSettingsManually = await getHotelConfig("SIDEBAR");
    const {
      userPrivileges: { authorizedFields }
    } = this.props;

    if (!authorizedFields.BOOKINGS) {
      menuItems = menuItems.filter(obj => obj.id !== "bookings");
    }
    if (!authorizedFields.PAYMENTS) {
      menuItems = menuItems.filter(obj => obj.id !== "payments");
    }
    if (
      !authorizedFields.ALACARTE ||
      (authorizedFields.ALACARTE && (hotelSettingsManually.alacarte === undefined || hotelSettingsManually.alacarte === false))
    ) {
      menuItems = menuItems.filter(obj => obj.id !== "alacarte");
    }
    if (
      !authorizedFields.LOLREQUESTS ||
      (authorizedFields.LOLREQUESTS && (hotelSettingsManually.lolRequests === undefined || hotelSettingsManually.lolRequests === false))
    ) {
      menuItems = menuItems.filter(obj => obj.id !== "lolRequests");
    }
    if (
      !authorizedFields.FAST_CHECK_IN ||
      (authorizedFields.FAST_CHECK_IN && (hotelSettingsManually.fastCheckin === undefined || hotelSettingsManually.fastCheckin === false))
    ) {
      menuItems = menuItems.filter(obj => obj.id !== "fastCheckin");
    }
    if (hotelSettingsManually.easee === undefined || hotelSettingsManually.easee === false) {
      menuItems = menuItems.filter(obj => obj.id !== "easee");
    }
    if (hotelSettingsManually.webeeadmin === undefined || hotelSettingsManually.webeeadmin === false || !authorizedFields.WEBEE_ADMIN) {
      menuItems = menuItems.filter(obj => obj.id !== "webeeadmin");
    }
    if (!authorizedFields.STAFF_TEMPLATE) {
      menuItems = menuItems.filter(obj => obj.id !== "settings");
    }

    if (this._isMounted === true) {
      this.setState({
        menuItems
      });
    }
  };

  openSubMenu = (e, menuItem) => {
    const selectedParent = menuItem.id;
    const hasSubMenu = menuItem.subs && menuItem.subs.length > 0;
    this.props.changeSelectedMenuHasSubItems(hasSubMenu);
    if (!hasSubMenu) {
      this.setState({
        viewingParentMenu: selectedParent,
        selectedParentMenu: selectedParent
      });
      this.toggle();
    } else {
      e.preventDefault();

      const { containerClassnames, menuClickCount } = this.props;
      const currentClasses = containerClassnames ? containerClassnames.split(" ").filter(x => x !== "") : "";

      if (!currentClasses.includes("menu-mobile")) {
        if (currentClasses.includes("menu-sub-hidden") && (menuClickCount === 2 || menuClickCount === 0)) {
          this.props.setContainerClassnames(3, containerClassnames, hasSubMenu);
        } else if (currentClasses.includes("menu-hidden") && (menuClickCount === 1 || menuClickCount === 3)) {
          this.props.setContainerClassnames(2, containerClassnames, hasSubMenu);
        } else if (
          currentClasses.includes("menu-default") &&
          !currentClasses.includes("menu-sub-hidden") &&
          (menuClickCount === 1 || menuClickCount === 3)
        ) {
          this.props.setContainerClassnames(0, containerClassnames, hasSubMenu);
        }
      } else {
        this.props.addContainerClassname("sub-show-temporary", containerClassnames);
      }
      this.setState({
        viewingParentMenu: selectedParent
      });
    }
  };

  render() {
    const { selectedParentMenu, viewingParentMenu, menuItems } = this.state;
    return (
      <div className="sidebar">
        <div className="main-menu">
          <div className="scroll">
            <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: false }}>
              <Nav vertical className="list-unstyled notranslate">
                {menuItems &&
                  menuItems.map((item, key) => {
                    return (
                      <NavItem
                        key={item.id}
                        className={classnames({
                          active: (selectedParentMenu === item.id && viewingParentMenu === "") || viewingParentMenu === item.id
                        })}
                      >
                        {item.newWindow ? (
                          <a href={item.to} rel="noopener noreferrer" target="_blank">
                            {item.id === "requests" ? (
                              <div>
                                {countArr[0] > 0 ? (
                                  <div style={{ paddingLeft: "45px" }}>
                                    <Badge color="danger" pill className="mb-1">
                                      {countArr[0]}
                                    </Badge>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : item.id === "bookings" ? (
                              <div>
                                {countArr[1] > 0 ? (
                                  <div style={{ paddingLeft: "45px" }}>
                                    <Badge color="danger" pill className="mb-1">
                                      {countArr[1]}
                                    </Badge>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : item.id === "fastCheckin" ? (
                              <div>
                                {countArr[2] > 0 ? (
                                  <div style={{ paddingLeft: "45px" }}>
                                    <Badge color="danger" pill className="mb-1">
                                      {countArr[2]}
                                    </Badge>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : item.id === "lolRequests" ? (
                              <div>
                                {countArr[3] > 0 ? (
                                  <div style={{ paddingLeft: "45px" }}>
                                    <Badge color="danger" pill className="mb-1">
                                      {countArr[3]}
                                    </Badge>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                            <i className={item.icon} /> <IntlMessages id={item.label} />
                          </a>
                        ) : (
                          <NavLink to={item.to} onClick={e => this.openSubMenu(e, item)} data-flag={item.id}>
                            {item.id === "requests" ? (
                              <div>
                                {countArr[0] > 0 ? (
                                  <div style={{ paddingLeft: "45px" }}>
                                    <Badge color="danger" pill className="mb-1">
                                      {countArr[0]}
                                    </Badge>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : item.id === "bookings" ? (
                              <div>
                                {countArr[1] > 0 ? (
                                  <div style={{ paddingLeft: "45px" }}>
                                    <Badge color="danger" pill className="mb-1">
                                      {countArr[1]}
                                    </Badge>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : item.id === "fastCheckin" ? (
                              <div>
                                {countArr[2] > 0 ? (
                                  <div style={{ paddingLeft: "45px" }}>
                                    <Badge color="danger" pill className="mb-1">
                                      {countArr[2]}
                                    </Badge>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : item.id === "lolRequests" ? (
                              <div>
                                {countArr[3] > 0 ? (
                                  <div style={{ paddingLeft: "45px" }}>
                                    <Badge color="danger" pill className="mb-1">
                                      {countArr[3]}
                                    </Badge>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            ) : (
                              ""
                            )}
                            <i className={item.icon} />
                            <IntlMessages id={item.label} />
                          </NavLink>
                        )}
                      </NavItem>
                    );
                  })}
                <NavItem className="small" style={{ position: "fixed", bottom: "5px" }}>
                  ver.
                  {this.getMeta("app-version")}
                </NavItem>
              </Nav>
            </PerfectScrollbar>
          </div>
        </div>

        <div className="sub-menu">
          <div className="scroll">
            <PerfectScrollbar options={{ suppressScrollX: true, wheelPropagation: false }}>
              {menuItems &&
                menuItems.map(item => {
                  return (
                    <Nav
                      key={item.id}
                      className={classnames({
                        "d-block":
                          (this.state.selectedParentMenu === item.id && this.state.viewingParentMenu === "") ||
                          this.state.viewingParentMenu === item.id
                      })}
                      data-parent={item.id}
                    >
                      {item.subs &&
                        item.subs.map((sub, index) => {
                          return (
                            <NavItem key={`${item.id}_${index}`}>
                              {sub.newWindow ? (
                                <a href={sub.to} rel="noopener noreferrer" target="_blank">
                                  <i className={sub.icon} /> <IntlMessages id={sub.label} />
                                </a>
                              ) : sub.subs && sub.subs.length > 0 ? (
                                <Fragment>
                                  <NavLink to={sub.to} id={`${item.id}_${index}`}>
                                    <i className={sub.icon} /> <IntlMessages id={sub.label} />
                                  </NavLink>

                                  <UncontrolledCollapse toggler={`#${item.id}_${index}`}>
                                    <Nav className="third-level-menu">
                                      {sub.subs.map((thirdSub, thirdIndex) => {
                                        return (
                                          <NavItem key={`${item.id}_${index}_${thirdIndex}`}>
                                            {thirdSub.newWindow ? (
                                              <a href={thirdSub.to} rel="noopener noreferrer" target="_blank">
                                                <i className={thirdSub.icon} /> <IntlMessages id={thirdSub.label} />
                                              </a>
                                            ) : (
                                              <NavLink to={thirdSub.to}>
                                                <i className={thirdSub.icon} /> <IntlMessages id={thirdSub.label} />
                                              </NavLink>
                                            )}
                                          </NavItem>
                                        );
                                      })}
                                    </Nav>
                                  </UncontrolledCollapse>
                                </Fragment>
                              ) : (
                                <NavLink to={sub.to}>
                                  <i className={sub.icon} /> <IntlMessages id={sub.label} />
                                </NavLink>
                              )}
                            </NavItem>
                          );
                        })}
                    </Nav>
                  );
                })}
            </PerfectScrollbar>
          </div>
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  location: PropTypes.object.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  userPrivileges: PropTypes.object.isRequired,
  menuClickCount: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  containerClassnames: PropTypes.string.isRequired
};

const mapStateToProps = ({ menu, requestApp, bookingApp, auth, settings }) => {
  const { userPrivileges } = auth;
  const { locale, hotelConfig } = settings;
  const { allRequestItems, allFastCheckinItems, allLolRequestsItems } = requestApp;
  const { allBookingItems } = bookingApp;
  const { containerClassnames, subHiddenBreakpoint, menuHiddenBreakpoint, menuClickCount, selectedMenuHasSubItems } = menu;
  return {
    allRequestItems,
    allFastCheckinItems,
    allBookingItems,
    allLolRequestsItems,
    userPrivileges,
    containerClassnames,
    subHiddenBreakpoint,
    menuHiddenBreakpoint,
    menuClickCount,
    selectedMenuHasSubItems,
    hotelConfig
  };
};
export default withRouter(
  connect(
    mapStateToProps,
    {
      setContainerClassnames,
      addContainerClassname,
      changeDefaultClassnames,
      changeSelectedMenuHasSubItems
    }
  )(Sidebar)
);
